import { LocaleType } from "../constants/constants";
import { label } from "../common/dto/dto-annotation";
import { IUserWebhook } from "./user-webhook";
import { Profile } from "../common/model/profile";

export class ContextProfile {
    constructor(profile?: ContextProfile) {
        if (profile) {
            this.username = profile.username;
            this.contactEmail = profile.contactEmail;
            this.lang = profile.lang;
            this.isDownload = profile.isDownload;
            this.printerPaperFormat = profile.printerPaperFormat;
            this.updateDate = profile.updateDate;
            this.webhooks = profile.webhooks;
        }
    }

    public static fromModel(model: Profile) {
        return new ContextProfile({
            username: model.username,
            contactEmail: model.contactEmail,
            lang: model.lang,
            isDownload: model.isDownload,
            printerPaperFormat: model.printerPaperFormat,
            updateDate: model.updateDate,
            webhooks: model.webhooks,
        });
    }

    @label("model.profile.username")
    public username: string;

    public contactEmail: string;

    @label("model.profile.lang")
    public lang: LocaleType;

    @label("model.profile.isDownload")
    public isDownload: boolean;

    @label("model.profile.printerPaperFormat")
    public printerPaperFormat: string;

    @label("model.profile.updateDate")
    public updateDate: string;

    public webhooks: IUserWebhook[];
}
